import { Component, Input } from '@angular/core';
import { BaseButtonComponent } from '../base-button';
import { FromScreen } from 'src/app/models/from-screen';
import { Action, ActionType } from 'src/app/models/action';
import { saveAs } from 'file-saver';
import { HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-download-attached-resource-button',
  templateUrl: './download-attached-resource-button.component.html',
  styleUrls: ['./download-attached-resource-button.component.scss', '../base-button.scss'],
})
export class DownloadAttachedResourceButtonComponent extends BaseButtonComponent {
  @Input()
  alone: boolean;

  status: string;
  progress: number;

  downloadResource() {
    const resource = this.record.attachedResource;
    const userId = this.authService.isAuthenticated() ? this.userService.getUserId() : null;

    if (resource.mode === 'OPEN') {
      this.waiting = true;
      this.download(this.getCurrentScreen(), userId);
    } else {
      const action: Action = {
        type: ActionType.DOWNLOAD,
        recordId: this.record.id,
      };

      this.doAction(() => {
        this.download(this.getCurrentScreen(), userId);
      }, action);
    }
  }

  private download(from: FromScreen, userId: string) {
    const previousFormat = this.alone;
    this.alone = true;

    this.apiService.downloadAttachedResource(this.record.id, from, userId).subscribe(
      (event) => {
        if (event.type === HttpEventType.Sent) {
          this.status = 'button.download.starting';
        } else if (event.type === HttpEventType.DownloadProgress) {
          this.progress = (event.loaded * 100) / event.total;
          this.status = 'button.download.downloading';
        } else if (event.type === HttpEventType.Response) {
          const contentHeader = event.headers.get('Content-Disposition');
          const parts = contentHeader.split(';');
          const fileName = parts[1].split('=')[1].replace(/"/g, '');
          saveAs(event.body as any, fileName);

          this.waiting = false;
          this.alone = previousFormat;
          delete this.status;
          delete this.progress;
        }
      },
      (err) => {
        this.waiting = false;
        this.alone = previousFormat;
        throw err;
      }
    );
  }
}
